// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 10L8 18.6603L8 1.33975L23 10ZM4 1L6 1L6 23H4L4 1Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-flag-3-filled')
export default class Flag3FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flag-3-filled',
    }
  }
}
